import React, { useState } from 'react';
import { ChevronDown, Heart } from 'lucide-react';
import { Section, Button } from './ui';
import { fireAddToCart } from './pixel';
export const FAQ = () => {
  const faqs = [{
    q: '¿Qué incluye el manual?',
    a: 'Incluye más de 970 recetas naturales organizadas paso a paso, además de los 3 bonos exclusivos detallados en esta página.'
  }, {
    q: '¿Cómo recibo el acceso?',
    a: 'Inmediatamente después de tu compra, recibirás un correo electrónico con tus datos de acceso a nuestra plataforma privada donde podrás ver y descargar todo el material.'
  }, {
    q: '¿Necesito experiencia previa?',
    a: 'No, en absoluto. Todas las preparaciones están explicadas paso a paso de forma sencilla, pensadas para que cualquier persona pueda realizarlas en casa.'
  }, {
    q: '¿Los ingredientes son fáciles de conseguir?',
    a: 'Sí, la gran mayoría de los ingredientes son hierbas comunes, especias y elementos que puedes encontrar en cualquier mercado local o tienda naturista.'
  }, {
    q: '¿Cuánto tiempo tengo acceso?',
    a: 'El acceso es de por vida. Pagas una sola vez y puedes acceder al manual y sus actualizaciones para siempre.'
  }, {
    q: '¿Funciona para cualquier edad?',
    a: 'Sí, las preparaciones naturales son beneficiosas para adultos de todas las edades. Siempre recomendamos consultar con un profesional para casos específicos.'
  }, {
    q: '¿Cómo funciona la garantía?',
    a: 'Tienes 7 días para revisar todo el material. Si sientes que no es para ti, solo nos envías un correo y te devolvemos el 100% de tu dinero, sin preguntas.'
  }, {
    q: '¿Por qué cuesta tan poco?',
    a: 'Queremos que este conocimiento ancestral llegue a la mayor cantidad de personas posible. Al ser un producto digital, reducimos costos de impresión y envío.'
  }, {
    q: '¿Puedo verlo desde el celular?',
    a: 'Sí, la plataforma está 100% optimizada para que puedas leer y consultar las recetas desde tu celular, tablet o computadora.'
  }, {
    q: '¿Es un producto físico o digital?',
    a: 'Es un producto 100% digital. Esto te permite tener acceso inmediato hoy mismo sin esperar tiempos de envío.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section bg="cream" data-id="element-422">
      <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-423">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-petroleum" data-id="element-424">
          Preguntas Frecuentes
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-425">
        {faqs.map((faq, i) => <div key={i} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-426">
            <button className="w-full px-6 py-4 text-left flex justify-between items-center font-bold text-petroleum hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-427">
              <span data-id="element-428">{faq.q}</span>
              <ChevronDown className={`transform transition-transform ${openIndex === i ? 'rotate-180' : ''}`} size={20} data-id="element-429" />
            </button>
            <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === i ? 'max-h-40 py-4 border-t border-gray-100' : 'max-h-0 py-0'}`} data-id="element-430">
              <p className="text-gray-600" data-id="element-431">{faq.a}</p>
            </div>
          </div>)}
      </div>
    </Section>;
};
export const EmotionalClose = () => {
  return <Section bg="dark" className="text-center relative overflow-hidden" data-id="element-432">
      {/* Background ambient glows */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-433"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-herbal/10 rounded-full blur-[120px] pointer-events-none" data-id="element-434"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-435">
        {/* Decorative top ornament */}
        <div className="flex items-center justify-center gap-3 mb-6" data-id="element-436">
          <div className="h-px w-16 bg-gradient-to-r from-transparent to-gold/60" data-id="element-437"></div>
          <span className="text-gold text-xs font-bold tracking-[0.3em]" data-id="element-438">
            ✦ TU MOMENTO ES AHORA ✦
          </span>
          <div className="h-px w-16 bg-gradient-to-l from-transparent to-gold/60" data-id="element-439"></div>
        </div>

        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-cream mb-8 leading-tight" data-id="element-440">
          "Tu cuerpo lleva años pidiendo ayuda...{' '}
          <span className="text-gold italic" data-id="element-441">
            hoy finalmente puedes escuchar lo que necesita.
          </span>
          "
        </h2>

        <div className="space-y-5 text-lg md:text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-442">
          <p data-id="element-443">
            Recuerda cómo te has sentido durante tanto tiempo:{' '}
            <span className="text-white font-semibold" data-id="element-444">
              agotada, frustrada y cansada de buscar soluciones que no
              funcionan.
            </span>
          </p>
          <p data-id="element-445">
            Hoy tienes acceso a una alternativa{' '}
            <span className="text-gold font-semibold" data-id="element-446">
              natural, práctica y accesible
            </span>{' '}
            que puede ayudarte a recuperar bienestar y tranquilidad desde casa.
          </p>
          <p className="italic text-gold/90 text-base md:text-lg pt-2 border-t border-gold/20" data-id="element-447">
            La pregunta no es <span className="font-bold" data-id="element-448">"¿funcionará?"</span>{' '}
            — la pregunta es:
            <br data-id="element-449" />
            <span className="font-bold text-white" data-id="element-450">
              ¿Cuánto tiempo más vas a esperar para sentirte mejor?
            </span>
          </p>
        </div>

        {/* Featured ancestral image */}
        <div className="relative max-w-2xl mx-auto mb-10 group" data-id="element-451">
          {/* Animated golden ring */}
          <div className="absolute -inset-2 bg-gradient-to-r from-gold via-yellow-300 to-gold rounded-[28px] blur-xl opacity-50 group-hover:opacity-80 transition-opacity duration-700 animate-pulse-slow" data-id="element-452"></div>
          <div className="relative rounded-[24px] overflow-hidden border-4 border-gold/60 shadow-[0_25px_60px_-15px_rgba(201,168,76,0.5)]" data-id="element-453">
            <img src="https://cdn.magicpatterns.com/uploads/ggXMmpS9cJQaqGZKfjVD4g/ChatGPT_Image_7_may_2026,_12_37_16_p.m.png" alt="El conocimiento herbal ancestral reunido en un solo sistema digital" className="w-full h-auto object-cover" data-id="element-454" />
          </div>
        </div>

        {/* Last-chance scarcity badge */}
        <div className="inline-flex items-center gap-2 bg-urgency/20 border border-urgency/40 text-urgency px-4 py-2 rounded-full text-xs font-bold tracking-widest mb-6 backdrop-blur-sm" data-id="element-455">
          <span className="relative flex h-2 w-2" data-id="element-456">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-urgency opacity-75" data-id="element-457"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-urgency" data-id="element-458"></span>
          </span>
          OFERTA POR TIEMPO LIMITADO · 93% DE DESCUENTO
        </div>

        {/* Premium 3D gold-bordered CTA */}
        <div className="relative inline-block w-full max-w-2xl mb-6 group" data-id="element-459">
          {/* Outer animated gold halo */}
          <div className="absolute -inset-1 bg-gradient-to-r from-yellow-400 via-gold to-yellow-400 rounded-full blur-md opacity-80 group-hover:opacity-100 transition-opacity animate-pulse-slow" data-id="element-460"></div>

          <a href="https://rutinaspracticas.com/cart/53026745483586:1" onClick={() => fireAddToCart()} className="relative block w-full bg-gradient-to-b from-[#27AE60] to-[#1E8449] hover:from-[#2ECC71] hover:to-[#27AE60] text-white font-bold py-5 md:py-6 px-6 md:px-10 rounded-full text-lg md:text-2xl border-[3px] border-gold transition-all duration-300 transform hover:scale-[1.02] overflow-hidden" style={{
          boxShadow: '0 0 0 1px rgba(201,168,76,0.8), 0 15px 40px -8px rgba(39,174,96,0.6), 0 8px 20px -6px rgba(201,168,76,0.5), inset 0 2px 0 rgba(255,255,255,0.25), inset 0 -3px 0 rgba(0,0,0,0.2)'
        }} data-id="element-461">
            <span className="relative z-10 flex items-center justify-center gap-3 whitespace-nowrap" data-id="element-462">
              <Heart size={22} fill="currentColor" data-id="element-463" />
              SÍ, QUIERO RECUPERAR MI BIENESTAR
            </span>
            {/* Shine sweep on hover */}
            <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" data-id="element-464"></span>
          </a>
        </div>

        {/* Trust microcopy */}
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs md:text-sm text-gray-400 mb-4" data-id="element-465">
          <span className="flex items-center gap-1.5" data-id="element-466">🔒 Pago 100% seguro</span>
          <span className="text-gold/40" data-id="element-467">•</span>
          <span className="flex items-center gap-1.5" data-id="element-468">⚡ Acceso inmediato</span>
          <span className="text-gold/40" data-id="element-469">•</span>
          <span className="flex items-center gap-1.5" data-id="element-470">💚 Garantía 7 días</span>
        </div>

        <p className="text-gray-400 text-sm italic" data-id="element-471">
          Únete a{' '}
          <span className="text-gold font-bold not-italic" data-id="element-472">
            +27.000 personas
          </span>{' '}
          que ya comenzaron su transformación natural.
        </p>
      </div>
    </Section>;
};
export const Footer = () => {
  return <footer className="bg-[#0A2A2B] text-gray-400 py-12 text-center text-sm" data-id="element-473">
      <div className="max-w-[1200px] mx-auto px-4" data-id="element-474">
        <div className="flex flex-wrap justify-center gap-6 mb-8" data-id="element-475">
          <a href="#" className="hover:text-white transition-colors" data-id="element-476">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-477">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-478">
            Aviso Legal
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-479">
            Contacto
          </a>
        </div>

        <div className="max-w-4xl mx-auto border-t border-white/10 pt-8" data-id="element-480">
          <p className="italic text-xs leading-relaxed opacity-70" data-id="element-481">
            "Este producto tiene fines educativos y de bienestar general. No
            sustituye atención médica profesional. Los resultados pueden variar
            según cada persona y aplicación individual."
          </p>
          <p className="mt-6 text-xs opacity-50" data-id="element-482">
            &copy; {new Date().getFullYear()} El Gran Manual Herbal. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
};